var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99984 11.3334C6.82917 11.3334 6.65851 11.2681 6.52851 11.1381C6.26784 10.8774 6.26784 10.4561 6.52851 10.1954L8.73184 7.99208L6.61184 5.79675C6.35651 5.53142 6.36384 5.10942 6.62851 4.85408C6.89384 4.59875 7.31584 4.60608 7.57117 4.87008L10.1458 7.53675C10.3985 7.79875 10.3952 8.21408 10.1378 8.47142L7.47117 11.1381C7.34117 11.2681 7.17051 11.3334 6.99984 11.3334Z",
    fill: "#19262F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDark);
export default __webpack_public_path__ + "static/media/chevronRightDark.ed3bae3f.svg";
export { ForwardRef as ReactComponent };